import { bodyStore } from "@/store/bodyStore";
import { selectingPartStore } from "@/store/partsStore";
import { BodyPart } from "@/types/design";

// カラーボール コンポーネントで使うロジックを提供します。
export default function useColor() {
	const { body, updateBody } = bodyStore();
	const { selectingPart } = selectingPartStore();

	// カラーボールクリック時の処理
	const initialColor = () => {
		const targetPart = body.find(
			(m: BodyPart) => m.partName === selectingPart.partName,
		);
		const fillColor = targetPart?.partStyle.fill ?? "#000000";
		return fillColor;
	};

	const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const selectedColor = e.target.value;
		const newBody = body.map((part: BodyPart) => {
			const selectingPartName = selectingPart.partName;
			const targetPart = body.find(
				(m: BodyPart) => m.partName === part.partName,
			);
			// パーツIdが存在することでパーツが設定されていることがわかる
			const isSetted = targetPart?.partId;
			if (isSetted && selectingPartName === part.partName) {
				if (selectingPartName == "eyes") {
					const [fill_1, fill_2, fill_3] = getShades(selectedColor);
					const updatedPartStyle = {
						...part.partStyle,
						fill: selectedColor,
						fill_1: fill_1,
						fill_2: fill_2,
						fill_3: fill_3,
					};

					return {
						...part,
						partStyle: updatedPartStyle,
					};
				} else if (
					selectingPartName == "hair" ||
					selectingPartName == "backHair"
				) {
					const [fill_1, fill_2, fill_3] = getShades(selectedColor);
					const updatedPartStyle = {
						...part.partStyle,
						fill: selectedColor,
						line: fill_1,
					};

					return {
						...part,
						partStyle: updatedPartStyle,
					};
				} else {
					const updatedPartStyle = {
						...part.partStyle,
						fill: selectedColor,
					};
					return {
						...part,
						partStyle: updatedPartStyle,
					};
				}
			}
			return part;
		});
		updateBody(newBody);
	};

	const getShades = (hexColor: string) => {
		// hexColor を RGB に変換
		const hex = hexColor.replace("#", "");
		const r = parseInt(hex.substring(0, 2), 16);
		const g = parseInt(hex.substring(2, 4), 16);
		const b = parseInt(hex.substring(4, 6), 16);

		// 濃淡を生成（%を掛ける）
		const shades = [0.9, 0.75, 0.5].map((factor) => {
			const newR = Math.round(r * factor);
			const newG = Math.round(g * factor);
			const newB = Math.round(b * factor);
			return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
		});

		return shades;
	};

	// 2桁の16進数に変換（先頭0埋め）
	const toHex = (value: number) => {
		return value.toString(16).padStart(2, "0");
	};

	return {
		initialColor,
		handleColorChange,
	};
}
